var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-view',{staticClass:"fd-unlocked-template-modal-view",attrs:{"size":550,"icon":"warning","title":_vm.$_('fd.unlocked.template.modal.title'),"dialog":false,"buttons":[{
		label: _vm.$_('fd.unlocked.template.modal.actions.ok'),
		css: 'primary'
	}]}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$_('fd.unlocked.template.modal.content', { shop: _vm.shop }))}})])}
var staticRenderFns = []

export { render, staticRenderFns }